import  React  from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import AddAdvise from "./AddAdvise";
import PhoneLogin from "./PhoneLogin";
import UpdateAdvise from "./UpdateAdvise"
import marketfeed_bg_dark from "./assets/marketfeed_bg_dark.svg";
const regeneratorRuntime = require("regenerator-runtime");

const headerStyle = {
  background: "black",
  display: "flex",
  justifyContent: "center",
  padding: 5,
}

const Routes = () => (
  <>
    <div
      style={headerStyle}
    >
      <img src={marketfeed_bg_dark} alt="Logo" />
    </div>
    <Router>
      <Switch>
        <Route path="/add-advise" component={() => <AddAdvise />} />
        <Route path="/phone-login" component={() => <PhoneLogin />} />
        <Route path="/update-advise" component={() => <UpdateAdvise />} />
        <Route path="/" component={() => <Dashboard />} />
      </Switch>
    </Router>
  </>
);

export default Routes;
